import { gqlClient } from '../../components/AppProvider';
import { Person, MutationStatusCode } from '../../gql-types.generated';
import { queryApteanAdminUsers } from './QueryApteanAdminUsers';
import { mutationUpsertApteanAdmin } from '../../gql/MutationUpsertApteanAdmin';
import { mutationDeleteApteanAdmin } from '../../gql/MutationDeleteApteanAdmin';
import { AppDispatch, AppThunk } from '../../store';
import { decrementRequestsInFlight, incrementRequestsInFlight } from '../app/AppSlice';
import {
  fetchError,
  fetchApteanAdminUsersSuccess,
  captureUpsertPersonStatus,
  captureDeletePersonStatus,
} from './ApteanAdminUsersSlice';

export const fetchApteanAdminUsers =
  (): AppThunk =>
  async (dispatch: AppDispatch): Promise<void> => {
    dispatch(incrementRequestsInFlight());

    try {
      const userList = await queryApteanAdminUsers(gqlClient);
      if (userList) {
        dispatch(fetchApteanAdminUsersSuccess(userList as Person[]));
      }
      dispatch(decrementRequestsInFlight());
    } catch (e) {
      dispatch(fetchError(e));
      dispatch(decrementRequestsInFlight());
    }
  };

export const upsertApteanAdminData =
  (firstName: string, lastName: string, email: string, id?: string): AppThunk =>
  async (dispatch: AppDispatch): Promise<void> => {
    dispatch(incrementRequestsInFlight());

    try {
      const upsertStatus = await mutationUpsertApteanAdmin(gqlClient, { email, id, firstName, lastName });
      if (upsertStatus) {
        if (upsertStatus.code === MutationStatusCode.Error) {
          dispatch(fetchError({ message: upsertStatus.message } as Error));
        }
        dispatch(captureUpsertPersonStatus(upsertStatus));
      }
      dispatch(decrementRequestsInFlight());
    } catch (e) {
      console.error(e);
      dispatch(fetchError(e));
      dispatch(decrementRequestsInFlight());
    }
  };

export const deleteApteanAdminData =
  (id: string): AppThunk =>
  async (dispatch: AppDispatch): Promise<void> => {
    dispatch(incrementRequestsInFlight());

    try {
      const deleteStatus = await mutationDeleteApteanAdmin(gqlClient, id);
      if (deleteStatus) {
        if (deleteStatus.code === MutationStatusCode.Error) {
          dispatch(fetchError({ message: deleteStatus.message } as Error));
        }
        dispatch(captureDeletePersonStatus(deleteStatus));
      }
      dispatch(decrementRequestsInFlight());
    } catch (e) {
      console.error(e);
      dispatch(fetchError(e));
      dispatch(decrementRequestsInFlight());
    }
  };
